import { Alert } from "antd";

import { getAiErrorMessage } from "@fitness-app/data-models/ai/error-message";

export function AiRequestErrorAlert({ error }: { error: unknown }) {
  const message = getAiErrorMessage(error);
  const description = message.includes("ERR max request size exceeded")
    ? "Generator przekroczył limit rozmiaru danych podczas zapisywania stanu."
    : message;

  return <Alert className="mt-3" type="error" message="Generator zakończył się błędem" description={description} />;
}
